import 'reflect-metadata';

import { DynamicMetadataType } from '../types/dynamic-metadata-type.enum';
import { IDynamicPropertyMetadata } from '../types/dynamic-property-metadata.interface';

export function DynamicProperty(metadata?: IDynamicPropertyMetadata): PropertyDecorator {
  return (target: object, propertyKey: string | symbol) => {
    const properties = Reflect.getMetadata(DynamicMetadataType.Properties, target) ?? [];
    Reflect.defineMetadata(DynamicMetadataType.Properties, [...properties, propertyKey], target);

    Reflect.defineMetadata(DynamicMetadataType.Property, metadata, target, propertyKey);
  };
}
